import * as React from "react"
import { Slot } from "@radix-ui/react-slot"
import { cva } from "class-variance-authority";

import { cn } from "@/lib/utils"

const buttonVariants = cva(
  "inline-flex items-center justify-center gap-2 whitespace-nowrap rounded-md text-sm font-medium transition-colors focus-visible:outline-none focus-visible:ring-1 focus-visible:ring-ring disabled:pointer-events-none disabled:opacity-50 [&_svg]:pointer-events-none [&_svg]:size-4 [&_svg]:shrink-0",
  {
    variants: {
      variant: {
        default:
          "border border-primary/50 bg-primary/85 text-primary-foreground shadow backdrop-blur-md hover:bg-primary dark:bg-primary/25 dark:text-white dark:hover:bg-primary/40 dark:hover:border-primary/70",
        destructive:
          "border border-destructive/50 bg-destructive/85 text-destructive-foreground shadow-sm backdrop-blur-md hover:bg-destructive dark:bg-destructive/25 dark:text-white dark:hover:bg-destructive/40",
        outline:
          "border border-input bg-white/50 shadow-sm backdrop-blur-md hover:bg-white/75 hover:text-accent-foreground dark:border-white/15 dark:bg-white/5 dark:hover:bg-white/10 dark:hover:text-foreground",
        secondary:
          "border border-white/10 bg-secondary/60 text-secondary-foreground shadow-sm backdrop-blur-md hover:bg-secondary/80",
        ghost: "hover:bg-black/5 hover:text-accent-foreground dark:hover:bg-white/10",
        link: "text-primary underline-offset-4 hover:underline",
      },
      size: {
        default: "h-9 px-4 py-2",
        sm: "h-8 rounded-md px-3 text-xs",
        lg: "h-10 rounded-md px-8",
        icon: "h-9 w-9",
      },
    },
    defaultVariants: {
      variant: "default",
      size: "default",
    },
  }
)

const Button = React.forwardRef(({ className, variant, size, asChild = false, ...props }, ref) => {
  const Comp = asChild ? Slot : "button"
  return (
    <Comp
      className={cn(buttonVariants({ variant, size, className }))}
      ref={ref}
      {...props} />
  );
})
Button.displayName = "Button"

export { Button, buttonVariants }
